import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowUp18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.25012 3.81075L3.53051 8.53037L2.46985 7.46971L9.00018 0.939377L15.5305 7.46971L14.4698 8.53037L9.75012 3.81064L9.75012 17H8.25012L8.25012 3.81075Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowUp18.displayName = 'ArrowUp18';
export default ArrowUp18;
